import { LevelData } from '../level-data';

export const level9: LevelData = {
    name: 'Mixed Tiles',
    timeLimit: 90,
    track: [
        '-------',
        '-------',
        '-------',
        '-------',
        '-------',
        '---B---',
        '-------',
        '-------',
        '-------',
        '---S---',
        '-------',
        '-------',
        '-------',
        '---  --',
        '-------',
        '-------',
        '-------',
        '---B---',
        '-------',
        '-------',
        '-------',
        '  ---  ',
        '-------',
        '-------',
        '-------',
        '---S---',
        '-------',
        '-------',
        '-------',
        '---B---',
        '-------',
        '-------',
        '-------',
        '---  --',
        '-------',
        '-------',
        '-------',
        '-------',
        '-------',
        '-------',
        '-------',
        '-------',
        '-------',
        '-------',
        '-------',
        '-------',
        '-------',
        '-------',
        '-------',
        '-------',
        'FFFFFFF',
    ],
};
